import i18n from "i18next";

// Texts of the invoice preview popup, shared by every feature that opens it
const resources = {
  en: {
    einvoice_submitted: "Submitted",
    einvoice_pending: "Pending",
    einvoice_in_progress: "In Progress",
    einvoice_failed: "Failed",
    einvoice_cancelled: "Cancelled",
    einvoice_not_submitted: "Not Submitted",
    error_loading_invoice: "Error loading invoice",
    invoice_not_found: "Invoice not found",
    invoice_analytics: "Invoice Analytics",
    patient_to_insurance: "Patient / Insurance",
    patient: "Patient",
    insurance: "Insurance",
    payment_progress: "Payment Progress",
    paid: "Paid",
    national_id: "National ID",
    insurance_number: "Insurance Number",
    invoice_details: "Invoice Details",
    subtotal: "Subtotal",
    discount: "Discount",
    tax: "Tax",
    total: "Total",
    insurance_company: "Insurance Company",
    doctor: "Doctor",
    branch: "Branch",
    created_at: "Created At",
    total_paid: "Total Paid",
    remaining: "Remaining",
    payments: "payments",
    paid_in_full: "Paid in Full",
    pending_payment: "Pending Payment",
    operations: "Operations",
    more_operations: "more operations",
    patient_einvoice: "Patient E-Invoice",
    claim: "Claim",
    not_in_claim: "Not in a claim",
    claim_invoice_not_issued: "Claim invoice not issued",
    view_full_details: "View Full Details",
    invoice_preview: "Invoice Preview",
  },
  ar: {
    einvoice_submitted: "تم الإرسال",
    einvoice_pending: "قيد الانتظار",
    einvoice_in_progress: "قيد المعالجة",
    einvoice_failed: "فشل",
    einvoice_cancelled: "ملغى",
    einvoice_not_submitted: "لم يتم الإرسال",
    error_loading_invoice: "خطأ في تحميل الفاتورة",
    invoice_not_found: "الفاتورة غير موجودة",
    invoice_analytics: "تحليلات الفاتورة",
    patient_to_insurance: "المريض / التأمين",
    patient: "المريض",
    insurance: "التأمين",
    payment_progress: "تقدم الدفع",
    paid: "مدفوع",
    national_id: "الهوية الوطنية",
    insurance_number: "رقم التأمين",
    invoice_details: "تفاصيل الفاتورة",
    subtotal: "المجموع الفرعي",
    discount: "الخصم",
    tax: "الضريبة",
    total: "الإجمالي",
    insurance_company: "شركة التأمين",
    doctor: "الطبيب",
    branch: "الفرع",
    created_at: "تاريخ الإنشاء",
    total_paid: "إجمالي المدفوع",
    remaining: "المتبقي",
    payments: "دفعات",
    paid_in_full: "مدفوع بالكامل",
    pending_payment: "دفعة معلقة",
    operations: "العمليات",
    more_operations: "عمليات أخرى",
    patient_einvoice: "فاتورة المريض الإلكترونية",
    claim: "المطالبة",
    not_in_claim: "ليست ضمن مطالبة",
    claim_invoice_not_issued: "لم تُصدر فاتورة المطالبة",
    view_full_details: "عرض التفاصيل الكاملة",
    invoice_preview: "معاينة الفاتورة",
  },
  fr: {
    einvoice_submitted: "Soumis",
    einvoice_pending: "En attente",
    einvoice_in_progress: "En cours",
    einvoice_failed: "Échoué",
    einvoice_cancelled: "Annulé",
    einvoice_not_submitted: "Non soumis",
    error_loading_invoice: "Erreur lors du chargement de la facture",
    invoice_not_found: "Facture introuvable",
    invoice_analytics: "Analyse de la facture",
    patient_to_insurance: "Patient / Assurance",
    patient: "Patient",
    insurance: "Assurance",
    payment_progress: "Progression du paiement",
    paid: "Payé",
    national_id: "Identité nationale",
    insurance_number: "Numéro d'assurance",
    invoice_details: "Détails de la facture",
    subtotal: "Sous-total",
    discount: "Remise",
    tax: "Taxe",
    total: "Total",
    insurance_company: "Compagnie d'assurance",
    doctor: "Médecin",
    branch: "Succursale",
    created_at: "Créé le",
    total_paid: "Total payé",
    remaining: "Restant",
    payments: "paiements",
    paid_in_full: "Payé intégralement",
    pending_payment: "Paiement en attente",
    operations: "Opérations",
    more_operations: "plus d'opérations",
    patient_einvoice: "E-Facture Patient",
    claim: "Réclamation",
    not_in_claim: "Hors réclamation",
    claim_invoice_not_issued: "Facture de réclamation non émise",
    view_full_details: "Voir tous les détails",
    invoice_preview: "Aperçu de la facture",
  },
  it: {
    einvoice_submitted: "Inviato",
    einvoice_pending: "In attesa",
    einvoice_in_progress: "In corso",
    einvoice_failed: "Fallito",
    einvoice_cancelled: "Annullato",
    einvoice_not_submitted: "Non inviato",
    error_loading_invoice: "Errore nel caricamento della fattura",
    invoice_not_found: "Fattura non trovata",
    invoice_analytics: "Analisi fattura",
    patient_to_insurance: "Paziente / Assicurazione",
    patient: "Paziente",
    insurance: "Assicurazione",
    payment_progress: "Progresso pagamento",
    paid: "Pagato",
    national_id: "Documento d'identità",
    insurance_number: "Numero assicurazione",
    invoice_details: "Dettagli fattura",
    subtotal: "Subtotale",
    discount: "Sconto",
    tax: "Tassa",
    total: "Totale",
    insurance_company: "Compagnia assicurativa",
    doctor: "Medico",
    branch: "Filiale",
    created_at: "Creato il",
    total_paid: "Totale pagato",
    remaining: "Rimanente",
    payments: "pagamenti",
    paid_in_full: "Pagato interamente",
    pending_payment: "Pagamento in sospeso",
    operations: "Operazioni",
    more_operations: "altre operazioni",
    patient_einvoice: "E-Fattura Paziente",
    claim: "Richiesta",
    not_in_claim: "Non in una richiesta",
    claim_invoice_not_issued: "Fattura della richiesta non emessa",
    view_full_details: "Vedi dettagli completi",
    invoice_preview: "Anteprima fattura",
  },
  ckb: { // Sorani Kurdish
    einvoice_submitted: "نێردراوە",
    einvoice_pending: "چاوەڕوانە",
    einvoice_in_progress: "لە کاردایە",
    einvoice_failed: "سەرنەکەوت",
    einvoice_cancelled: "هەڵوەشێنرا",
    einvoice_not_submitted: "نێردرانەوە",
    error_loading_invoice: "هەڵە لە بارکردنی پسوڵە",
    invoice_not_found: "پسوڵە نەدۆزرایەوە",
    invoice_analytics: "شیکاری پسوڵە",
    patient_to_insurance: "نەخۆش / بیمە",
    patient: "نەخۆش",
    insurance: "بیمە",
    payment_progress: "پێشکەوتنی پارەدان",
    paid: "پارەدراوە",
    national_id: "ناسنامەی نیشتمانی",
    insurance_number: "ژمارەی بیمە",
    invoice_details: "وردەکاری پسوڵە",
    subtotal: "کۆی لاوەکی",
    discount: "داشکان",
    tax: "باج",
    total: "کۆی گشتی",
    insurance_company: "کۆمپانیای بیمە",
    doctor: "پزیشک",
    branch: "لق",
    created_at: "دروستکراوە لە",
    total_paid: "کۆی پارەدراو",
    remaining: "ماوە",
    payments: "پارەدانەکان",
    paid_in_full: "بە تەواوی پارەدراوە",
    pending_payment: "پارەدانی چاوەڕوان",
    operations: "نەشتەرگەرییەکان",
    more_operations: "نەشتەرگەریی زیاتر",
    patient_einvoice: "پسوڵەی ئەلیکترۆنیی نەخۆش",
    claim: "داواکاری",
    not_in_claim: "لە داواکارییەکدا نییە",
    claim_invoice_not_issued: "پسوولەی داواکاری دەرنەکراوە",
    view_full_details: "بینینی وردەکاری تەواو",
    invoice_preview: "پێشبینینی پسوڵە",
  },
  ku: { // Kurmanji Kurdish
    einvoice_submitted: "Şandî",
    einvoice_pending: "Li benda ye",
    einvoice_in_progress: "Di pêvajoyê de",
    einvoice_failed: "Bi ser neket",
    einvoice_cancelled: "Betalkirî",
    einvoice_not_submitted: "Neşandî",
    error_loading_invoice: "Çewtiya barkirina fatûreyê",
    invoice_not_found: "Fature nehat dîtin",
    invoice_analytics: "Analîza Fatûreyê",
    patient_to_insurance: "Nexweş / Bîme",
    patient: "Nexweş",
    insurance: "Bîme",
    payment_progress: "Pêşveçûna Dayînê",
    paid: "Dayîn",
    national_id: "Nasnameya Neteweyî",
    insurance_number: "Hejmara Bîmeyê",
    invoice_details: "Hûrguliyên Fatûreyê",
    subtotal: "Binkoma",
    discount: "Dakêşan",
    tax: "Bac",
    total: "Giştî",
    insurance_company: "Şirketa Bîmeyê",
    doctor: "Bijîşk",
    branch: "Şax",
    created_at: "Hatiye afirandin",
    total_paid: "Giştî dayîn",
    remaining: "Dimîne",
    payments: "dayîn",
    paid_in_full: "Bi tevahî dayîn",
    pending_payment: "Dayîna li benda",
    operations: "Emeliyat",
    more_operations: "bêtir emeliyat",
    patient_einvoice: "E-Fatûreya Nexweş",
    claim: "Daxwaz",
    not_in_claim: "Ne di daxwazekê de",
    claim_invoice_not_issued: "Fatûreya daxwazê nehatiye derxistin",
    view_full_details: "Hemû hûrguliyan bibîne",
    invoice_preview: "Pêşdîtina Fatûreyê",
  },
  el: { // Greek
    einvoice_submitted: "Υποβλήθηκε",
    einvoice_pending: "Εκκρεμεί",
    einvoice_in_progress: "Σε εξέλιξη",
    einvoice_failed: "Απέτυχε",
    einvoice_cancelled: "Ακυρώθηκε",
    einvoice_not_submitted: "Δεν υποβλήθηκε",
    error_loading_invoice: "Σφάλμα φόρτωσης τιμολογίου",
    invoice_not_found: "Τιμολόγιο δεν βρέθηκε",
    invoice_analytics: "Ανάλυση τιμολογίου",
    patient_to_insurance: "Ασθενής / Ασφάλιση",
    patient: "Ασθενής",
    insurance: "Ασφάλιση",
    payment_progress: "Πρόοδος πληρωμής",
    paid: "Πληρωμένο",
    national_id: "Εθνική ταυτότητα",
    insurance_number: "Αριθμός ασφάλισης",
    invoice_details: "Στοιχεία τιμολογίου",
    subtotal: "Μερικό σύνολο",
    discount: "Έκπτωση",
    tax: "Φόρος",
    total: "Σύνολο",
    insurance_company: "Ασφαλιστική εταιρεία",
    doctor: "Γιατρός",
    branch: "Υποκατάστημα",
    created_at: "Δημιουργήθηκε",
    total_paid: "Συνολικά πληρωμένο",
    remaining: "Υπόλοιπο",
    payments: "πληρωμές",
    paid_in_full: "Εξοφλήθηκε πλήρως",
    pending_payment: "Εκκρεμής πληρωμή",
    operations: "Θεραπείες",
    more_operations: "περισσότερες θεραπείες",
    patient_einvoice: "Ηλ. Τιμολόγιο Ασθενή",
    claim: "Αξίωση",
    not_in_claim: "Εκτός αξίωσης",
    claim_invoice_not_issued: "Το τιμολόγιο αξίωσης δεν εκδόθηκε",
    view_full_details: "Δείτε πλήρη στοιχεία",
    invoice_preview: "Προεπισκόπηση τιμολογίου",
  },
  nl: { // Dutch
    einvoice_submitted: "Ingediend",
    einvoice_pending: "In afwachting",
    einvoice_in_progress: "In behandeling",
    einvoice_failed: "Mislukt",
    einvoice_cancelled: "Geannuleerd",
    einvoice_not_submitted: "Niet ingediend",
    error_loading_invoice: "Fout bij laden van factuur",
    invoice_not_found: "Factuur niet gevonden",
    invoice_analytics: "Factuuranalyse",
    patient_to_insurance: "Patiënt / Verzekering",
    patient: "Patiënt",
    insurance: "Verzekering",
    payment_progress: "Betalingsvoortgang",
    paid: "Betaald",
    national_id: "Nationaal ID",
    insurance_number: "Verzekeringsnummer",
    invoice_details: "Factuurdetails",
    subtotal: "Subtotaal",
    discount: "Korting",
    tax: "Belasting",
    total: "Totaal",
    insurance_company: "Verzekeringsmaatschappij",
    doctor: "Arts",
    branch: "Vestiging",
    created_at: "Aangemaakt op",
    total_paid: "Totaal betaald",
    remaining: "Resterend",
    payments: "betalingen",
    paid_in_full: "Volledig betaald",
    pending_payment: "Betaling in afwachting",
    operations: "Behandelingen",
    more_operations: "meer behandelingen",
    patient_einvoice: "Patiënt E-Factuur",
    claim: "Claim",
    not_in_claim: "Niet in een claim",
    claim_invoice_not_issued: "Claimfactuur niet uitgegeven",
    view_full_details: "Volledige details bekijken",
    invoice_preview: "Factuurvoorbeeld",
  },
  pl: { // Polish
    einvoice_submitted: "Przesłano",
    einvoice_pending: "Oczekuje",
    einvoice_in_progress: "W trakcie",
    einvoice_failed: "Niepowodzenie",
    einvoice_cancelled: "Anulowano",
    einvoice_not_submitted: "Nie przesłano",
    error_loading_invoice: "Błąd ładowania faktury",
    invoice_not_found: "Nie znaleziono faktury",
    invoice_analytics: "Analiza faktury",
    patient_to_insurance: "Pacjent / Ubezpieczenie",
    patient: "Pacjent",
    insurance: "Ubezpieczenie",
    payment_progress: "Postęp płatności",
    paid: "Zapłacono",
    national_id: "Numer identyfikacyjny",
    insurance_number: "Numer ubezpieczenia",
    invoice_details: "Szczegóły faktury",
    subtotal: "Suma częściowa",
    discount: "Rabat",
    tax: "Podatek",
    total: "Suma",
    insurance_company: "Firma ubezpieczeniowa",
    doctor: "Lekarz",
    branch: "Oddział",
    created_at: "Utworzono",
    total_paid: "Łącznie zapłacono",
    remaining: "Pozostało",
    payments: "płatności",
    paid_in_full: "Zapłacono w całości",
    pending_payment: "Oczekująca płatność",
    operations: "Zabiegi",
    more_operations: "więcej zabiegów",
    patient_einvoice: "E-Faktura Pacjenta",
    claim: "Roszczenie",
    not_in_claim: "Poza roszczeniem",
    claim_invoice_not_issued: "Faktura roszczenia nie wystawiona",
    view_full_details: "Zobacz pełne szczegóły",
    invoice_preview: "Podgląd faktury",
  },
};

export const addTranslationResources = (i18next: typeof i18n) => {
  i18next.addResourceBundle("en", "invoicePreview", resources.en);
  i18next.addResourceBundle("ar", "invoicePreview", resources.ar);
  i18next.addResourceBundle("fr", "invoicePreview", resources.fr);
  i18next.addResourceBundle("it", "invoicePreview", resources.it);
  i18next.addResourceBundle("ckb", "invoicePreview", resources.ckb);
  i18next.addResourceBundle("ku", "invoicePreview", resources.ku);
  i18next.addResourceBundle("el", "invoicePreview", resources.el);
  i18next.addResourceBundle("nl", "invoicePreview", resources.nl);
  i18next.addResourceBundle("pl", "invoicePreview", resources.pl);
};
